import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { routes } from '@libs/utils';

@Component({
  selector: 'lib-installation-pending',
  imports: [CommonModule, TranslateModule],
  templateUrl: './installation-pending.component.html',
  styleUrl: './installation-pending.component.scss',
})
export class InstallationPendingComponent {
  private readonly router = inject(Router);

  public onGoToShowCase(): void {
    this.router.navigate([routes.site, routes.showcaseSiteId, routes.home]);
  }
}
